import { Component, Input } from '@angular/core';
import { InternalIconComponent } from '@shared/components/internal-icon/internal-icon.component';

@Component({
  selector: 'app-jip-logo',
  templateUrl: './jip-logo.component.html',
  imports: [InternalIconComponent],
})
export class JipLogoComponent {
  @Input() name = 'logo';
  @Input() width: string;
  @Input() height: string;
}
